import { Component, OnChanges, DoCheck, ChangeDetectorRef } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterNumberRangeType} from './covance-filter-number-range-type';
import { FilterFieldValue } from '../covance-filter.models';

@Component({
    selector: 'covance-filter-number-range-type',
    template: require('./covance-filter-number-range-type.component.html'),
    styles: [require('./covance-filter-number-range-type.component.scss')]
})
export class CovanceFilterNumberRangeTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterNumberRangeType> implements OnChanges, DoCheck {
    public max: string;
    public min: string;

    private oldFieldValue: FilterFieldValue;

    constructor(filterType: CovanceFilterNumberRangeType, private changeDetectorRef: ChangeDetectorRef) {
        super(filterType);
    }

    public ngOnChanges() {
        this.oldFieldValue = this.fieldVal.value;
        if (this.fieldVal.value) {
            this.max = this.fieldVal.value.max;
            this.min = this.fieldVal.value.min;
        }
    }

    public ngDoCheck() {
        if (this.fieldVal.value !== this.oldFieldValue) {
            this.max = this.fieldVal.value.max;
            this.min = this.fieldVal.value.min;
            this.changeDetectorRef.markForCheck();
        }
    }

    public onMinChange($event: string) {
        this.min = $event;
        this.fieldVal.value.min = this.getNumberValue($event);
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }

    public onMaxChange($event: string) {
        this.max = $event;
        this.fieldVal.value.max = this.getNumberValue($event);
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }

    private getNumberValue(value: string): number {
        return this.filterType.isNumber(value) ? +value : null;
    }
}